import { ContentItemType } from '@lopo-tech/lopo-api'
import React from 'react'
import { RouteComponentProps } from 'react-router'

import PostDetailsPage from 'src/pages/post_details'

const SnapshotDetailsPage: React.FC<RouteComponentProps<{ id: string }>> = (routeProps) => (
  <PostDetailsPage {...routeProps} contentItemType={ContentItemType.Snapshot} />
)

export default SnapshotDetailsPage
